/* XYON brand wordmark — typographically emphasizes "Siloxys" within "SiloxysSystem(™)"
 *
 * Walks text nodes across the page (and any section rendered via the Shopify
 * Section Rendering API), wrapping matches with structural spans so CSS can
 * apply a weight bump + tracking shift to "Siloxys" while leaving "System"
 * and the ™ at the ambient weight.
 *
 * Idempotent: a text node is only processed once; nodes inside already-
 * wrapped wordmarks (or inside <script>/<style>/<code>/<textarea>) are
 * skipped.
 */
(function () {
  'use strict';

  var PATTERN = /SiloxysSystem(\u2122)?/g;
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, CODE: 1, PRE: 1, TEXTAREA: 1, NOSCRIPT: 1, IFRAME: 1 };
  var WRAP_CLASS = 'xyon-wordmark';

  function shouldSkip(textNode) {
    var el = textNode.parentElement;
    while (el) {
      if (SKIP_TAGS[el.tagName]) return true;
      if (el.classList && el.classList.contains(WRAP_CLASS)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function buildReplacement(text) {
    var frag = document.createDocumentFragment();
    var lastIdx = 0;
    var match;
    PATTERN.lastIndex = 0;
    while ((match = PATTERN.exec(text)) !== null) {
      var idx = match.index;
      if (idx > lastIdx) {
        frag.appendChild(document.createTextNode(text.slice(lastIdx, idx)));
      }
      var wrap = document.createElement('span');
      wrap.className = WRAP_CLASS;
      var head = document.createElement('span');
      head.className = WRAP_CLASS + '__head';
      head.textContent = 'Siloxys';
      wrap.appendChild(head);
      var tail = document.createElement('span');
      tail.className = WRAP_CLASS + '__tail';
      tail.textContent = 'System' + (match[1] || '');
      wrap.appendChild(tail);
      frag.appendChild(wrap);
      lastIdx = idx + match[0].length;
    }
    if (lastIdx < text.length) {
      frag.appendChild(document.createTextNode(text.slice(lastIdx)));
    }
    return frag;
  }

  function process(root) {
    if (!root || !root.nodeType) return;
    if (root.nodeType === Node.ELEMENT_NODE && SKIP_TAGS[root.tagName]) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || node.nodeValue.indexOf('SiloxysSystem') === -1) {
          return NodeFilter.FILTER_REJECT;
        }
        if (shouldSkip(node)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);

    for (var i = 0; i < nodes.length; i++) {
      var textNode = nodes[i];
      if (!textNode.parentNode) continue;
      var frag = buildReplacement(textNode.nodeValue);
      textNode.parentNode.replaceChild(frag, textNode);
    }
  }

  function run() {
    process(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-apply when sections are re-rendered via the Shopify Section Rendering API
  document.addEventListener('shopify:section:load', function (e) {
    process(e.target);
  });
})();
